import { useCallback, useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  DATA_ROOM_NODE_FULL_TAGS,
  DATA_ROOM_NODE_LONG_TAGS,
  DATA_ROOM_NODE_SHORT_TAGS,
  DATA_ROOM_NODE_TAG,
  DataRoomNode,
} from 'router/subrouters/DataRoom/models/DataRoomNode';
import DataRoomDocumentsContext from '../../../providers/DataRoomDocuments/DataRoomDocuments.context';
import DataRoomContext from 'router/subrouters/DataRoom/providers/DataRoom/DataRoom.context';
import { getIsNodeFile, normalizeText } from 'utils';

export default function useFindSuggestedDataRoomNodeWithTag(
  nodes: DataRoomNode[],
) {
  const { t } = useTranslation();

  const {
    dataRoom: { existTags },
  } = useContext(DataRoomContext);
  const { canTagFiles } = useContext(DataRoomDocumentsContext);

  const findSuggestedTag = useCallback(
    (node: DataRoomNode) => {
      const { name, tag, denyTagNudging } = node;

      const canSuggestTag =
        !tag && canTagFiles && !denyTagNudging && getIsNodeFile(node);

      if (!canSuggestTag) return;

      return Object.values(DATA_ROOM_NODE_TAG)
        .filter((tag) => !existTags.includes(tag))
        .find((value) => {
          const nameLC = normalizeText(name);
          const shortTag = t([DATA_ROOM_NODE_SHORT_TAGS[value]]);
          const longTag = normalizeText(t([DATA_ROOM_NODE_LONG_TAGS[value]]));
          const fullTag = normalizeText(t([DATA_ROOM_NODE_FULL_TAGS[value]]));

          return (
            nameLC.includes(fullTag) ||
            nameLC.includes(longTag) ||
            name.includes(shortTag)
          );
        });
    },
    [canTagFiles, existTags, t],
  );

  return useMemo(() => {
    const suggestedTags = nodes
      .map((el) => ({
        ...el,
        tag: findSuggestedTag(el),
      }))
      .filter(({ tag }) => !!tag);

    const nodeWithImTag = suggestedTags.find(
      ({ tag }) => tag === DATA_ROOM_NODE_TAG.IM,
    );

    return nodeWithImTag;
  }, [nodes, findSuggestedTag]);
}
